// extracted by mini-css-extract-plugin
export default {"imageContainer":"Tile_imageContainer__ysgR9","label":"Tile_label__ZCIj-","image":"Tile_image__L5q0i","tileContainer":"Tile_tileContainer__sfPwi","tileLink":"Tile_tileLink__LDpPK"};